import { Button, Modal } from "@shapr3d/frontend-lib";
import { useParams } from "react-router-dom";

import { useMutateProjectViewLink } from "../../hooks/useProjectViewLink";
import useTracker from "../../utils/useTracker";

import style from "./UnpublishConfirmationModal.module.css";

export const UnpublishConfirmationModal = ({
  open,
  onClose,
  viewLinkId,
}: {
  open: boolean;
  onClose: () => void;
  viewLinkId: string;
}) => {
  const { teamID } = useParams();
  const tracker = useTracker();
  const { mutate, error, isPending } = useMutateProjectViewLink({ teamID, onSuccess: onClose });

  return (
    <Modal open={open} onClose={onClose} size="small" title="Unpublish link">
      <div className={style.modalContainer}>
        <div>
          Are you sure you want to unpublish this link? This will remove access for all members.
        </div>
        <Button
          disabled={isPending}
          variant="red"
          onClick={() => {
            tracker.trackUnpublishConfirmed({
              activeTeamId: String(teamID),
              viewLinkId: viewLinkId,
            });
            mutate({ viewLinkId, body: { sharedState: "not_shared" } });
          }}
        >
          Unpublish link
        </Button>
        {error && (
          <div className={style.errorMessage}>
            <span>Something went wrong. Please try again.</span>
          </div>
        )}
      </div>
    </Modal>
  );
};
